import Hero from 'components/Hero/Hero';
import Layout from 'components/Layout/Layout';
import ModuleItem from 'components/Modules';
import { fetchAllPostSlugs, fetchBlogCategories, fetchLatestBlogPosts } from 'services/blog/ssr';
import { fetchBrandConfig } from 'services/config/ssr';
import { fetchPage } from 'services/page/ssr';
import mergeStaticProps, { StaticProps } from 'utils/mergeStaticProps';

export default function BlogPage({ page }: StaticProps<typeof fetchPage> & StaticProps<typeof fetchLatestBlogPosts>) {
  return (
    <Layout theme="dark">
      {page.hero && <Hero {...page.hero} />}
      {page.pageSections?.length ? page.pageSections.map(ModuleItem) : null}
    </Layout>
  );
}

export const getStaticProps = mergeStaticProps(
  { params: { slug: ['blog'] } },
  fetchBrandConfig,
  fetchBlogCategories,
  fetchPage,
  fetchLatestBlogPosts,
);

export const getStaticPaths = fetchAllPostSlugs;
